var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCheckFilledGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "BinDrop/Icon/check-filled"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z",
    fill: "#2B8747"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M7.5 12.5L10.5 15.5L16.5 9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheckFilledGreen);
export default __webpack_public_path__ + "static/media/icon-check-filled-green.c6adf3acfa75e4aa955f3e064d972cb5.svg";
export { ForwardRef as ReactComponent };